import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { performLogout } from '../api/authApi';

import { clearAuthCookies, getAuthCookie, removeCookie } from "../utils/authCookies";

type LogoutButtonProps = {
  /** Optional custom icon node (e.g. AppIcon). Falls back to ri-logout-box-line. */
  icon?: React.ReactNode;
};

const LogoutButton = ({ icon }: LogoutButtonProps) => {
  const navigate = useNavigate();

  const handleLogout = async (e: React.MouseEvent) => {
    e.preventDefault();
    const token = typeof window !== 'undefined' ? getAuthCookie("sessionToken") : null;
    try {
      await performLogout(token);
    } finally {
      // Extra safety at button level: always clear required cookies on click.
      clearAuthCookies();
      removeCookie("sessionToken");
      removeCookie("userType");
      removeCookie("userId");
      removeCookie("userName");
      removeCookie("licenseType");
    }
    navigate('/', { replace: true });
    window.location.reload();
  };

  return (
    <Link to="" onClick={handleLogout} className="nav-link menu-link d-flex gap-2 fs-14 fw-bold">
      {icon ?? <i className="ri-logout-box-line"></i>}{" "}
      <span data-key="t-dashboards">Logout</span>
    </Link>
  );
};

export default LogoutButton;
